<template>
  <v-navigation-drawer
    class="pt-5"
    width="500"
    :temporary="true"
    location="right"
    v-model="shareTrigger"
    @update:modelValue="shareTrigger = $event"
    :absolute="true"
    :scrim="true"
    :disable-resize-watcher="true"
    :disable-route-watcher="true"
  >
    <share-form
      :share-form-config="shareFormConfig"
      :realm="realm"
      :root="root"
      :mashup.sync="mashup"
    />
  </v-navigation-drawer>
</template>

<script>
import shareForm from "@/components/ShareForm";

export default {
  name: "SidebarShare",
  props: {
    dialogShare: Boolean,
    drawerShare: Boolean,
    realm: String,
    root: String,
    id: String,
    mashup: {},
    shareFormConfig: {},
  },
  components: {
    shareForm,
  },
  data() {
    return {
      tenantId: this.realm,
      urlPath: "",
      mashupId: "",
      mashupVersion: "",
    };
  },
  computed: {
    shareTrigger: {
      get() {
        return this.drawerShare;
      },
      set(value) {
        this.$emit("update:drawerShare", value);
      },
    },
  },
};
</script>
